import React, { useEffect, useMemo } from 'react';
import { useLocation, useParams } from 'react-router-dom';

interface Props {
  pathOverride?: string;
}

export const JarvisSalesAutomationRedirect: React.FC<Props> = ({ pathOverride }) => {
  const { pathname, search } = useLocation();
  const params = useParams();

  const jarvisBaseUrl = useMemo(() => {
    const rawBaseUrl = process.env.REACT_APP_JARVIS_BASE_URL?.trim();
    if (!rawBaseUrl) {
      // eslint-disable-next-line no-console
      console.error(
        '[JarvisSalesAutomationRedirect] REACT_APP_JARVIS_BASE_URL is empty. Sales automation redirect is disabled.'
      );
      return '';
    }

    return rawBaseUrl.replace(/\/+$/, '');
  }, []);

  const targetPath = useMemo(() => {
    if (!pathOverride) {
      return pathname;
    }

    return Object.entries(params).reduce((acc, [key, value]) => {
      if (!value) {
        return acc;
      }

      return acc.replace(`:${key}`, encodeURIComponent(value));
    }, pathOverride);
  }, [params, pathOverride, pathname]);

  useEffect(() => {
    if (!jarvisBaseUrl) {
      return;
    }

    window.location.replace(`${jarvisBaseUrl}${targetPath}${search}`);
  }, [jarvisBaseUrl, targetPath, search]);

  return null;
};
